<template>
  <div class="w-full">
    <BaseModal id="attributes-manager" v-model="addAttributeModal">
      <div class="flex flex-col p-4">
        <h2 class="mb-2">
          {{ $t("message.product_attributes.add_attributes") }}
        </h2>
        <label class="mt-4" for="attribute-type">{{
          $t("message.product_attributes.select_type")
        }}</label>
        <form class="flex flex-col" @submit.prevent="confirm">
          <select
            class="default-select bordered mt-2"
            name="attribute-type"
            id="attribute-type"
            v-model="attributeSelected"
            @change="getValues"
          >
            <option value="">Select Attribute</option>
            <option
              v-for="attribute in attributesOptions"
              :value="attribute.id"
              :key="attribute.id"
              >{{ attribute.attributeName }}</option
            >
          </select>
          <label class="mt-4" for="attribute-value">{{
            $t("message.product_attributes.select_value")
          }}</label>
          <select
            class="default-select bordered mt-2"
            name="attribute-value"
            id="attribute-value"
            v-model="attributeValueSelected"
          >
            <option value="">Select Value</option>
            <option
              v-for="attributeValue in attributesValuesOptions"
              :value="attributeValue.id"
              :key="attributeValue.id"
              >{{ attributeValue.value }}</option
            >
          </select>
          <input
            type="text"
            placeholder="New value"
            class="input regular bordered full mt-2"
            v-if="attributeValueSelected == null"
            v-model="customValue"
          />
          <div
            class="flex flex-row mt-4 justify-center items-center"
            v-if="optionsCount > 0"
          >
            <input
              type="checkbox"
              id="to-all-unificado"
              class="mr-2"
              v-model="addToAllUnificado"
            />
            <label for="to-all-unificado">
              Add to all unificado
            </label>
          </div>
          <button
            type="submit"
            class="btn-success-button full mt-4 mx-auto"
            v-if="isValid"
          >
            Add
          </button>
        </form>
      </div>
    </BaseModal>
    <table v-if="attributes.length > 0">
      <thead>
        <tr>
          <th>{{ $t("message.product_attributes.attribute") }}</th>
          <th>{{ $t("message.product_attributes.value") }}</th>
          <th>{{ $t("message.product_attributes.action") }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="attribute in attributes" :key="attribute.idRelation">
          <td>{{ attribute.attributeName }}</td>
          <td>{{ attribute.value }}</td>
          <td>
            <button
              v-if="userCanEditProducts"
              class="w-6"
              @click="deleteRelation(attribute.idRelation)"
            >
              <img class="w-full" src="@/assets/icons/trash.svg" />
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <div v-else>
      {{ $t("message.product_attributes.no_attributes") }}
    </div>
    <div v-if="userCanEditProducts" class="flex w-full justify-center">
      <button class="btn-dark-button mt-4" @click="addNewAttribute">
        {{ $t("message.product_attributes.add_attribute") }}
      </button>
    </div>
  </div>
</template>
<script>
import {
  getAttributes,
  getAttributesValuesOptions,
  addAttribute,
  addCustomAttribute,
  deleteAttributeRelation
} from "@/api/masterAdmin/AttributesService.js";
export default {
  name: "ProductAttributesManager",
  props: {
    code: {
      type: String,
      required: true
    },
    attributes: {
      type: Array,
      required: true
    },
    optionsCount: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      addAttributeModal: false,
      attributesOptions: [],
      attributesValuesOptions: [],
      attributeSelected: "",
      attributeValueSelected: "",
      customValue: "",
      addToAllUnificado: false
    };
  },
  computed: {
    userCanEditProducts() {
      return this.$store.getters["auth/userHasPermission"]("can_edit_products");
    },
    isValid() {
      if (
        this.attributeValueSelected !== "" &&
        this.attributeValueSelected !== null
      ) {
        return true;
      }
      if (this.customValue !== "") {
        return true;
      }
      return false;
    }
  },
  watch: {
    addAttributeModal(val) {
      if (val) {
        this.customValue = "";
        this.attributeValueSelected = "";
        this.attributeSelected = "";
      }
    }
  },
  async mounted() {
    this.attributesOptions = await getAttributes();
  },
  methods: {
    addNewAttribute() {
      this.addAttributeModal = true;
    },
    async getValues() {
      this.attributesValuesOptions = [];
      this.attributeValueSelected = "";
      this.attributesValuesOptions = [
        ...(await getAttributesValuesOptions(this.attributeSelected)),
        {
          attributeId: "custom",
          id: null,
          value: "new value"
        }
      ];
    },
    deleteRelation(id) {
      if (!confirm("do you want to delete this attribute?")) {
        return;
      }
      let deleteFromAll = false;
      if (
        this.optionsCount > 0 &&
        confirm("do you want to delete it from others unificados?")
      ) {
        deleteFromAll = true;
      }
      deleteAttributeRelation(id, deleteFromAll)
        .then(() => {
          this.$emit("newAttributeAdded");
          this.$toast.open({
            message: `Attribute deleted`,
            type: "success",
            position: "top-right"
          });
        })
        .catch(err => {
          this.$toast.open({
            message: `${err.response.data ?? err.message}`,
            type: "error",
            position: "top-right"
          });
        });
    },
    showError(err) {
      this.$toast.open({
        message: `${err.response.data ?? err.message}`,
        type: "error",
        position: "top-right"
      });
    },
    confirm() {
      if (this.isValid) {
        if (
          this.attributeValueSelected !== "" &&
          this.attributeValueSelected !== null
        ) {
          addAttribute(
            this.code,
            this.attributeValueSelected,
            this.addToAllUnificado
          )
            .then(() => {
              this.$toast.open({
                message: `Attribute added`,
                type: "success",
                position: "top-right"
              });
              this.$emit("newAttributeAdded");
              this.addAttributeModal = false;
            })
            .catch(err => {
              this.showError(err);
            });
        } else {
          addCustomAttribute(
            this.code,
            this.attributeSelected,
            this.customValue
          )
            .then(() => {
              this.$toast.open({
                message: `Attribute added`,
                type: "success",
                position: "top-right"
              });
              this.$emit("newAttributeAdded");
              this.addAttributeModal = false;
            })
            .catch(err => {
              this.showError(err);
            });
        }
      }
    }
  }
};
</script>
<style lang="scss">
#attributes-manager {
  .modal-content {
    max-width: 350px;
    height: auto;
  }
}
</style>
